export default "__VITE_ASSET__fec59fac__"